import { Box, Stack, useTheme } from "@mui/material";
import { Outlet } from "react-router";

type Props = {
    children?: ReactNode;
};
export const MainLayoutPaddingFree = (props: Props) => {
    const theme = useTheme();

    return (
        <Stack
            sx={{
                display: "flex",
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <Box
                sx={{
                    width: "100%",
                    maxWidth: theme.breakpoints.values.xl,
                }}
            >
                {props.children ? props.children : <Outlet />}
            </Box>
        </Stack>
    );
};
